module.exports = __webpack_public_path__ + "img/a7638df.jpg";